import React from 'react';
import { X } from 'lucide-react';

const AboutModal = ({ setShowAbout }) => {
  return (
    <div className="fixed inset-0 bg-gray-900/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white border border-gray-100 rounded-2xl shadow-xl w-full max-w-md max-h-[90vh] flex flex-col overflow-hidden">
        <div className="flex items-center justify-between px-7 py-5 border-b border-gray-100">
          <h2 className="text-gray-900 font-semibold text-lg tracking-tight">About</h2>
          <button onClick={() => setShowAbout(false)} className="text-gray-400 hover:text-gray-900 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-7 space-y-7 text-sm text-gray-600">
          <div>
            <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2">What is this?</p>
            <p className="leading-relaxed">
              Monthly Wealth Tracker helps you monitor your net worth over time by recording monthly snapshots of your assets and debts.
            </p>
          </div>

          <div>
            <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2">How to use</p>
            <ol className="space-y-2">
              {[
                'Add your asset and debt accounts in Manage Accounts.',
                'Each month, enter balances for all accounts.',
                'Review your history and performance over time.',
              ].map((step, i) => (
                <li key={i} className="flex gap-3">
                  <span className="text-accent shrink-0 font-medium">{i + 1}.</span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>

          <div>
            <p className="text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2">Privacy</p>
            <p className="leading-relaxed">
              No ads. No selling your data. Choose offline mode to keep everything local, or cloud mode to sync across devices.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutModal;
